/**
 * Clean-up of the old on-device store.
 *
 * Readings, notes and preferences used to live in an IndexedDB database that
 * was shared by every account signed in on the browser, so switching accounts
 * showed one person's history to another. The server is now the only copy,
 * and the leftover database is deleted so it can never be read back.
 */

const LEGACY_DB_NAME = '3ojo';

export function purgeLegacyDeviceData(): void {
  try {
    indexedDB.deleteDatabase(LEGACY_DB_NAME);
  } catch {
    // IndexedDB unavailable (some private modes): there is nothing to delete.
  }
}
